import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import UserMenu from '../containers/UserMenu'
import LeftMenuBar from '../containers/LeftMenuBar'
import LanguageMenu from '../containers/LanguageMenu'
import { useContext } from 'react'
import { Auth0Context } from '../../Auth0/components/Auth0Provider'

const LoginButton = () => {
  const auth0Context = useContext(Auth0Context)
  return (
    <Button color="inherit" onClick={auth0Context.login}>Login</Button>
  )
}

const styles = theme => ({
  root: {
    flexGrow: 1,
    position: 'fixed',
    zIndex: 1000,
    width: '100%',
    top: 0,
  },
  flex: {
    flex: 1,
  },
  spacer: {
    height: theme.spacing.unit * 9,
  },
  developMode: {
    top: 0,
    position: 'fixed',
    zIndex: 1000,
    height: theme.spacing.unit * 2,
    width: '100%',
    backgroundColor: 'red',
    textAlign: 'center',
  },
  toolbar: {
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: 1200,
    margin: '0 auto',
  },
  menuItemIcon: {
    color: theme.palette.grey[500]
  },
  actionBox: {
    display: 'flex',
    marginRight: -11,
  }
})

class MenuAppBar extends React.Component  {
  state = {
    open: false,
    anchorEl: null,
    atuh0: undefined,
  }
    
  componentDidMount () {
    const { resize } = this.props
    this.resize = (event) => {
      resize()
    }
    resize()
    window.addEventListener('resize', this.resize, true )
    window.addEventListener('orientationchange', this.resize, true)
    window.onerror = (errorMsg, fileName, lineNumber) => {
      var errorMessage = {
        'errorMsg'   : errorMsg,
        'fileName'   : fileName,
        'lineNumber' : lineNumber,
        'urlDispPage': window.location.href,
        'userAgent'  : navigator.userAgent
      };
      this.props.fetchErrorMessagePost(errorMessage)
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.resize, true )
    window.removeEventListener('orientationchange', this.resize, true)
  }
  
  render() {
    const { classes, user, isAuthStateChange, title, actions } = this.props
    var styles, isDevelopMode

    isDevelopMode = Boolean(process.env.NODE_ENV === 'production' && window.location.port === '3000')
    styles = {
      root: {
        top: isDevelopMode ? 16 : 0
      },
    }

    return (
      <div>
      {isDevelopMode && (
        <div className={classes.developMode}>
          <Typography variant='body2' style={{color: '#ffffff'}}>Develop</Typography>
        </div>
      )}
      <div className={classes.root} style={styles.root}>
        <AppBar position="static">
          <Toolbar className={classes.toolbar}>
            <LeftMenuBar />
            <Typography variant="title" color="inherit" noWrap className={classes.flex}>
              {title ? title : 'Renju Portal'}
            </Typography>
            <div className={classes.actionBox}>
              {isAuthStateChange && user ? (
                <React.Fragment>
                  <LanguageMenu/>
                  <UserMenu/>
                </React.Fragment>
              ) : isAuthStateChange && !user ? (
                <React.Fragment>
                  <LanguageMenu/>
                  <LoginButton/>
                </React.Fragment>
              ) : <div></div>}
              {actions && actions}
            </div>
          </Toolbar>
        </AppBar>
      </div>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(MenuAppBar)



// WEBPACK FOOTER //
// ./src/Parts/MenuAppBar/components/MenuAppBar.js